var _dec, _class;
import './cg-popup-space.scss';
import { inject } from 'aurelia-framework';
import { EventAggregator } from 'aurelia-event-aggregator';
import { device__desktop as desktop } from 'resources/constants';
export let CgPopupSpace = (_dec = inject(EventAggregator), _dec(_class = class CgPopupSpace {
  constructor(eventAggregator) {
    this.eventAggregator = eventAggregator;
    this.desktop = desktop;
  }
  attached() {
    this.windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    this.handleEventSubscriptions();
  }
  async detached() {
    this.sizeChanged?.dispose();
  }
  handleEventSubscriptions() {
    this.sizeChanged = this.eventAggregator.subscribe('size-changed', payload => {
      this.width = payload.width;
      this.hide();
    });
    this.setMaxHeight = this.eventAggregator.subscribe('popup-changed', payload => {
      this.popup.style.minHeight = payload;
      this.popup.style.maxHeight = payload;
    });
  }
  show(props) {
    if (this.width >= desktop) return;
    this.eventAggregator.publish('opened-veriff-dialog', {
      openedVeriffDialog: true,
      triggerDeviceStyling: true
    });
    if (this.width > desktop) {
      return;
    }
    this.bottomPopup.show(true, props);
    setTimeout(() => {
      this.popupSpace.style.transform = 'translateY(0)';
    }, 300);
    setTimeout(() => {
      this.backbox.classList.add('back-box-end');
    }, 700);
  }
  hide() {
    this.eventAggregator.publish('opened-veriff-dialog', {
      openedVeriffDialog: false,
      triggerDeviceStyling: true
    });
    this.backbox?.classList.add('back-box-removed');
    this.bottomPopup?.hide();
    setTimeout(() => {
      this.backbox?.classList.remove('back-box-end', 'back-box-removed');
      if (this.popupSpace) this.popupSpace.style.transform = 'translateY(100%)';
    }, 400);
  }
}) || _class);